import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

export default function CountdownTimer() {
  const [hours, setHours] = useState("");
  const [minutes, setMinutes] = useState("");
  const [seconds, setSeconds] = useState("");
  const [timeLeft, setTimeLeft] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const intervalRef = useRef(null);
  const audioRef = useRef(null);

  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hrs = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const mins = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
    const secs = String(totalSeconds % 60).padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };

  useEffect(() => {
    if (isRunning && timeLeft > 0) {
      intervalRef.current = setInterval(() => {
        setTimeLeft((prev) => prev - 1000);
      }, 1000);
    } else if (isRunning && timeLeft <= 0) {
      clearInterval(intervalRef.current);
      setIsRunning(false);
      if (audioRef.current) audioRef.current.play();
    }
    return () => clearInterval(intervalRef.current);
  }, [isRunning, timeLeft]);

  const handleStart = () => {
    const totalMs =
      parseInt(hours || 0) * 60 * 60 * 1000 +
      parseInt(minutes || 0) * 60 * 1000 +
      parseInt(seconds || 0) * 1000;

    if (totalMs > 0) {
      setTimeLeft(totalMs);
      setIsRunning(true);
    } else {
      alert("Enter a valid time");
    }
  };

  const handleReset = () => {
    setIsRunning(false);
    clearInterval(intervalRef.current);
    setTimeLeft(0);
    setHours("");
    setMinutes("");
    setSeconds("");
  };

  return (
    <>
      <Helmet>
        <title>Countdown Timer Online - Set Custom Timer with Alarm Sound</title>
        <meta
          name="description"
          content="Use our free online Countdown Timer to set a custom timer in hours, minutes, and seconds. Get notified with an alarm sound when the time is up."
        />
        <meta name="keywords" content="countdown timer, free timer tool, online timer, set countdown, timer with alarm, timer for events" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/countdown-timer" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container text-center mt-5">
          <BackButton />
          <h2>Countdown Timer</h2>

          <div className="row justify-content-center my-4">
            <div className="col-md-2">
              <input
                type="number"
                className="form-control"
                placeholder="Hours"
                value={hours}
                onChange={(e) => setHours(e.target.value)}
                min="0"
              />
            </div>
            <div className="col-md-2">
              <input
                type="number"
                className="form-control"
                placeholder="Minutes"
                value={minutes}
                onChange={(e) => setMinutes(e.target.value)}
                min="0"
                max="59"
              />
            </div>
            <div className="col-md-2">
              <input
                type="number"
                className="form-control"
                placeholder="Seconds"
                value={seconds}
                onChange={(e) => setSeconds(e.target.value)}
                min="0"
                max="59"
              />
            </div>
          </div>

          <h1 className="display-4 mb-4">{formatTime(timeLeft)}</h1>

          <div className="mb-4">
            <button
              className="btn btn-success me-2"
              onClick={handleStart}
              disabled={isRunning}
            >
              Start
            </button>
            <button className="btn btn-danger" onClick={handleReset}>
              Reset
            </button>
          </div>

          <audio ref={audioRef}>
            <source src="https://www.soundjay.com/button/sounds/beep-07.mp3" type="audio/mpeg" />
          </audio>
        </div>
      </section>
    </>
  );
}
